module.exports = __webpack_public_path__ + "img/_0.25e00767.png";